import { createForm } from '@seek/forms-ui';
import { useTranslations } from '@vocab/react';
import { Box, Stack } from 'braid-design-system';
import React, { useState } from 'react';

import { useConfig } from 'src/shared/hooks';
import type { Language } from 'src/shared/types';
import { getQueryString } from 'src/utils/helpers';

import { Form, FormIntro, ThanksView } from './components';
import translations from './components/SubjectData/.vocab';

const FORM_NAME = 'contact-us-form';

interface FormValues {
  firstName: string;
  lastName: string;
  telephone: string;
  email: string;
  subject: string;
  reason: string;
  additionalInformation: string;
  preferredContactMethod: string;
  preferredContactTime: string;
}

const { FormProvider, useField } = createForm<FormValues, any, Language>(
  FORM_NAME,
);
export { useField };

export const EnquiryForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const { isAnz, language } = useConfig();
  const enquiryQuery = isAnz ? '' : getQueryString('enquiry');
  const { t } = useTranslations(translations);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let validQuery = false;

  const getSubjectReason = () => {
    switch (enquiryQuery) {
      case 'page-not-found':
        validQuery = true;
        return {
          subject: t('Other'),
          reason: t('Product feedback'),
          additionalInformation: '',
        };
      case 'page-load-failed':
        validQuery = true;
        return {
          subject: t('Other'),
          reason: t('Product feedback'),
          additionalInformation: '',
        };
      default:
        return {
          subject: '',
          reason: '',
          additionalInformation: '',
        };
    }
  };

  const initialValues = {
    firstName: '',
    lastName: '',
    telephone: '',
    email: '',
    preferredContactMethod: 'Any',
    preferredContactTime: 'Any',
    ...getSubjectReason(),
  };
  return (
    <Box>
      {submitted ? (
        <ThanksView clearSubmitted={() => setSubmitted(false)} />
      ) : (
        <Stack space="xlarge">
          <FormIntro />
          <FormProvider initialValues={initialValues} language={language}>
            {({ handleSubmit, resetForm, setFieldValue }) => (
              <Form
                handleSubmit={handleSubmit}
                setSubmitted={setSubmitted}
                setFieldValue={setFieldValue}
                resetForm={resetForm}
              />
            )}
          </FormProvider>
        </Stack>
      )}
    </Box>
  );
};
